module.exports = __webpack_public_path__ + "img/loading.b0654363.gif";